<script lang="ts" setup>
import { User, UserLevel } from '@/models/user.model';
import { ShiftCMSState } from '@/store';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore<ShiftCMSState>();
const user = computed<User | null>(() => store.state.loggedInUser);
const language = computed<string>(() => store.getters.language);

const items = computed(() => [
  {
    title: 'Categories',
    value: 'categories',
    props: {
      to: '/categories',
      active: route.path === '/categories',
    },
  },
  {
    title: 'Users',
    value: 'users',
    props: {
      to: '/users',
      active: route.path === '/users',
    },
  },
  {
    title: 'Stories',
    value: 'stories',
    props: {
      to: '/stories',
      active: route.path === '/stories',
    },
  },
  {
    title: 'Daily Quiz',
    value: 'quiz-of-the-day',
    props: {
      to: '/quiz-of-the-day',
      active: route.path === '/quiz-of-the-day',
    },
  },
  {
    title: 'CO₂ Quiz',
    value: 'co2quiz',
    props: {
      to: '/co2quiz',
      active: route.path === '/co2quiz',
    },
  },
  {
    title: 'BTP',
    value: 'bpt',
    props: {
      to: '/bpt',
      active: route.path === '/bpt',
    },
  },
  {
    title: 'Insight',
    value: 'insight',
    props: {
      to: '/insight',
      active: route.path === '/insight',
    },
  },
  {
    title: 'Content',
    value: 'content',
    props: {
      to: '/content',
      active: route.path === '/content',
    },
  },
  {
    title: 'Learning',
    value: 'learning',
    props: {
      to: '/learning',
      active: route.path === '/learning',
    },
  },
  {
    title: 'Events',
    value: 'events',
    props: {
      to: '/events',
      active: route.path === '/events',
    },
  },
  {
    title: 'Goals',
    value: 'goals',
    props: {
      to: '/goals',
      active: route.path === '/goals',
    },
  },
  {
    title: 'Municipalities',
    value: 'municipalities',
    props: {
      to: '/municipalities',
      active: route.path === '/municipalities',
    },
  },
  {
    title: 'Locations',
    value: 'locations',
    props: {
      to: '/locations',
      active: route.path === '/locations',
    },
  },
  {
    title: 'Labels',
    value: 'labels',
    props: {
      to: '/labels',
      active: route.path === '/labels',
    },
  },
  {
    title: 'Data Tables',
    value: 'data-tables',
    props: {
      to: '/data-tables',
      active: route.path === '/data-tables',
    },
  },
  {
    title: 'Feedback',
    value: 'feedback',
    props: {
      to: '/feedback',
      active: route.path === '/feedback',
    },
  },
  {
    title: 'Statistics',
    value: 'statistics',
    props: {
      to: '/statistics',
      active: route.path === '/statistics',
    },
  },
  {
    title: 'Translations',
    value: 'translations',
    props: {
      to: '/translations',
      active: route.path === '/translations',
    },
  },
]);

const contentEditorItems = computed(() => [
  {
    title: 'Lijst',
    value: 'initiative-list',
    props: {
      to: '/initiative/list',
      active: route.path === '/initiative/list',
    },
  },
]);
</script>
<template>
  <v-navigation-drawer app location="left" width="140" permanent>
    <v-list-item title="Shift CMS" :subtitle="language" to="/"></v-list-item>
    <v-divider></v-divider>
    <v-list :items="items" v-if="user?.level === UserLevel.Admin"></v-list>
    <v-list
      :items="contentEditorItems"
      v-if="user?.level === UserLevel.ContentEditor"
    ></v-list>
  </v-navigation-drawer>
</template>
<style scoped>
.v-navigation-drawer {
  z-index: 150 !important;
}
</style>
